import React, { useState, useEffect, useCallback } from 'react';
import { Typography } from '@mui/material';

const TypewriterText = ({ 
  text, 
  speed = 30, 
  delay = 0, 
  variant = "body1", 
  sx = {},
  onComplete = () => {},
  showCursor = true
}) => {
  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(false);
  const [hasCompleted, setHasCompleted] = useState(false);

  const handleComplete = useCallback(() => {
    if (!hasCompleted) {
      setHasCompleted(true);
      onComplete();
    }
  }, [onComplete, hasCompleted]);

  useEffect(() => {
    if (delay > 0) {
      const delayTimer = setTimeout(() => {
        setIsTyping(true);
      }, delay);
      return () => clearTimeout(delayTimer);
    } else {
      setIsTyping(true);
    }
  }, [delay]);

  useEffect(() => {
    if (!isTyping || currentIndex >= text.length) {
      if (currentIndex >= text.length && !hasCompleted) {
        handleComplete();
      }
      return;
    }

    const timer = setTimeout(() => {
      setDisplayText(prev => prev + text[currentIndex]);
      setCurrentIndex(prev => prev + 1);
    }, speed);

    return () => clearTimeout(timer);
  }, [currentIndex, text, speed, isTyping, handleComplete, hasCompleted]);

  // Reset state when text changes
  useEffect(() => {
    setDisplayText('');
    setCurrentIndex(0);
    setIsTyping(false);
    setHasCompleted(false);
  }, [text]);

  return (
    <Typography variant={variant} sx={sx}>
      {displayText}
      {showCursor && isTyping && currentIndex < text.length && (
        <span style={{ 
          borderRight: '2px solid #569cd6', 
          animation: 'blink 1s infinite',
          marginLeft: '2px'
        }} />
      )}
      <style>
        {`
          @keyframes blink {
            0%, 50% { border-color: #569cd6; }
            51%, 100% { border-color: transparent; }
          }
        `}
      </style>
    </Typography>
  );
};

export default TypewriterText;
